/**
 * The UrbanClean mark, drawn as inline SVG: the navy shield with the blue
 * washing-machine drum inside it. Same shapes the mobile splash animates.
 */
export default function Logo({ size = 34, showText = true, light = false }) {
  const navy = light ? '#ffffff' : '#1f3468';
  const blue = light ? '#9ecbf0' : '#3182c8';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
        {/* shield */}
        <path
          d="M32 2 60 12v22c0 15-12 25-28 28C16 59 4 49 4 34V12L32 2Z"
          fill={navy}
        />
        {/* machine body */}
        <rect x="14" y="15" width="36" height="34" rx="4" fill="#fff" />
        <rect x="14" y="15" width="36" height="7" rx="3.5" fill="#fff" />
        <rect x="18" y="17.5" width="9" height="2.6" rx="1.3" fill={navy} />
        <circle cx="33" cy="18.8" r="1.7" fill="none" stroke={blue} strokeWidth="1" />
        <circle cx="39" cy="18.8" r="1.2" fill={navy} />
        <circle cx="43.5" cy="18.8" r="1.2" fill={navy} />
        <rect x="14" y="24" width="36" height="1.4" fill={navy} />
        {/* drum */}
        <circle cx="32" cy="37" r="11.5" fill="#fff" stroke={navy} strokeWidth="2.6" />
        <circle cx="32" cy="37" r="8.5" fill={blue} />
        {/* water + bubbles */}
        <path d="M23.5 36.5c3-2.5 5.5-1 8 .3s5 2 7.5-.3v4.5c-2.5 2.2-5 1.3-7.5 0s-5-2.8-8-.3v-4.2Z" fill="#fff" />
        <circle cx="34.5" cy="32.5" r="1.5" fill="#fff" />
        <circle cx="38" cy="35" r="1" fill="#fff" />
      </svg>

      {showText ? (
        <div style={{ lineHeight: 1.1 }}>
          <div style={{ fontWeight: 800, fontSize: size * 0.44, letterSpacing: '-0.3px' }}>
            <span style={{ color: navy }}>URBAN</span>
            <span style={{ color: blue }}> CLEAN</span>
          </div>
          <div style={{ fontSize: size * 0.235, color: light ? 'rgba(255,255,255,.7)' : '#6b7a95', marginTop: 1 }}>
            Admin Panel
          </div>
        </div>
      ) : null}
    </div>
  );
}
